import { createSvgIcon } from "@mui/material";

export const ExcelIcon = createSvgIcon(
  <svg width="25" height="26" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="7.8125" y="4.66669" width="14.0625" height="16.4062" rx="3.125" fill="#2FB776" />
    <path
      d="M7.8125 16.9714H21.875V17.9479C21.875 19.6738 20.4759 21.0729 18.75 21.0729H10.9375C9.21161 21.0729 7.8125 19.6738 7.8125 17.9479V16.9714Z"
      fill="url(#paint0_linear_22_24701)"
    />
    <rect x="14.8438" y="12.8698" width="7.03125" height="4.10156" fill="#229C5B" />
    <rect x="14.8438" y="8.76825" width="7.03125" height="4.10156" fill="#27AE68" />
    <path
      d="M7.8125 7.79169C7.8125 6.0658 9.21161 4.66669 10.9375 4.66669H14.8437V8.76825H7.8125V7.79169Z"
      fill="#1D854F"
    />
    <rect x="7.8125" y="8.76825" width="7.03125" height="4.10156" fill="#197B43" />
    <rect x="7.8125" y="12.8698" width="7.03125" height="4.10156" fill="#1B5B38" />
    <path
      d="M7.8125 12.2839C7.8125 10.3422 9.3865 8.76825 11.3281 8.76825V8.76825C13.2698 8.76825 14.8438 10.3422 14.8438 12.2839V14.6276C14.8438 17.2165 12.7451 19.3151 10.1562 19.3151H7.8125V12.2839Z"
      fill="black"
      fillOpacity="0.3"
    />
    <rect
      x="3.125"
      y="7.59619"
      width="10.5469"
      height="10.5469"
      rx="3.125"
      fill="url(#paint1_linear_22_24701)"
    />
    <path
      d="M10.7422 15.7996L9.09109 12.8113L10.6697 9.94025H9.38104L8.40649 11.7734L7.44805 9.94025H6.11912L7.70578 12.8113L6.05469 15.7996H7.34335L8.38233 13.8577L9.41326 15.7996H10.7422Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_22_24701"
        x1="7.8125"
        y1="19.0222"
        x2="21.875"
        y2="19.0222"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#2F6145" />
        <stop offset="1" stop-color="#1BE076" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_22_24701"
        x1="3.125"
        y1="12.8696"
        x2="13.6719"
        y2="12.8696"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#258849" />
        <stop offset="1" stop-color="#1DA056" />
      </linearGradient>
    </defs>
  </svg>,
  "ExcelIcon"
);
